export default __webpack_public_path__ + "static/OurMission3-682734e9f75fd1018800e45e91101249.svg";